import { styled } from "@mui/material/styles"

export function styledForMobile(component, otherProps = []) {
    const propsToNotForward = otherProps.concat(["isMobile"])
    return styled(component, { shouldForwardProp: prop => !(propsToNotForward.includes(prop)) })
}